import {ArrowRight, KeyRound} from "lucide-react";
import {useState, type FormEvent} from "react";
import {useNavigate} from "react-router-dom";
import {verifySession} from "../api";
import {setAccessToken} from "../session";

export const LoginPage = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    setAccessToken(token.trim());
    try {
      await verifySession();
      navigate("/tasks", {replace: true});
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "访问口令无效");
      setBusy(false);
    }
  };
  return (
    <main className="login-page">
      <section className="login-title">
        <p className="eyebrow">PRIVATE PRODUCTION DESK</p>
        <h1>把素材交给<br />本地制作流程</h1>
        <p>手机上传图片和音频，本地电脑自动生成带字幕的 3:4 视频。</p>
      </section>
      <form className="login-form" onSubmit={(event) => void submit(event)}>
        <div className="form-number">01 / ACCESS</div>
        <KeyRound size={28} />
        <label htmlFor="access-token">访问口令</label>
        <input id="access-token" type="password" inputMode="numeric" autoComplete="current-password" value={token} onChange={(event) => setToken(event.target.value)} minLength={6} required autoFocus />
        {error ? <p className="form-error" role="alert">{error}</p> : null}
        <button className="button button-primary" type="submit" disabled={busy || token.trim().length < 6}>
          {busy ? "正在验证" : "进入制作台"}<ArrowRight size={19} />
        </button>
      </form>
    </main>
  );
};
